import { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Theme } from '@material-ui/core/styles/createTheme';
import Button from '@material-ui/core/Button';
import EndCallButton from '../Buttons/EndCallButton/EndCallButton';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '600px',
    minHeight: '300px',
  },
  paper: {
    background: 'rgba(4, 74, 117, 0.7)',
    color: 'white',
  },
  title: {
    textAlign: 'center',
    width: 'calc(100% - 35px)',
    paddingBottom: '1em',
    color: '#FFF',
  },
  copyContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingBottom: '1em',
  },
  inputContainer: {
    width: '100%',
    paddingBottom: '10px',
  },
  input: {
    fontFamily: 'inherit',
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, 0.7)',
    color: '#000000',
    textAlign: 'center',
    border: 'none',
    borderRadius: '5px',
    fontSize: '18px',
    padding: '18.5px 14px',
    outline: 'none',
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  copyButton: {
    width: 'calc(50% - 5px)',
    background: 'var(--sib-color_primary-default, #0071c7)',
    color: '#FFFFFF',
    fontSize: 'var(--sib-typo_text-md-font-size, 1rem)',
    '&:hover': {
      background: 'var(--sib-color_primary-hover, #005494)',
    },
  },
  leaveButton: {
    width: 'calc(50% - 5px)',
    fontSize: '18px',
  },
});

export default function CopyLinkPopup() {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const roomLink = window.location.hostname + window.location.pathname;
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const [copyButtonState, setcopyButtonState] = useState<string>(t('ROOM.INVITE.COPY_LINK'));
  const copyTextRef = useRef<HTMLInputElement>(null);

  const copyToClipboard = () => {
    if (null !== copyTextRef.current) {
      copyTextRef.current.select();
      document.execCommand('copy');
      setcopyButtonState(t('ROOM.INVITE.COPIED_LINK'));
      setTimeout(() => {
        setcopyButtonState(t('ROOM.INVITE.COPY_LINK'));
      }, 2000);
    }
  };

  if (isMobile) return null; // Don't render this component on a mobile device

  return (
    <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{ classes: { root: classes.paper } }}>
      <DialogContent className={classes.container}>
        <div className={clsx(classes.title, 'sib-typo_heading-lg')}>{t('ROOM.INVITE.TITLE')}</div>
        <div className={classes.copyContainer}>
          <div className={classes.inputContainer}>
            <input type="url" ref={copyTextRef} className={classes.input} readOnly defaultValue={roomLink} />
          </div>
          <div className={classes.buttonContainer}>
            {document.queryCommandSupported('copy') && (
              <Button
                onClick={copyToClipboard}
                className={classes.copyButton}
                variant="contained"
                type="button"
                color="primary"
              >
                {copyButtonState}
              </Button>
            )}
            <EndCallButton className={classes.leaveButton} />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
